import HeroBanner from "./components/banner-section";
import Faq from "./components/faq";
import FeaturedProducts from "./components/featured-product";
import ResearchNotice from "./components/research-notice";
import TrustFeatures from "./components/trust-feature";
import { useEffect, useState } from "react";
import pagesApi from "./admincomponents/PagesApi";

function App() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    pagesApi.get("home").then(setContent).catch(() => setContent({}));
  }, []);

  return (
    <div>
        <HeroBanner content={content} />
        <TrustFeatures content={content} />
        <ResearchNotice content={content} />
        <FeaturedProducts content={content} />
        <Faq content={content} />
    </div>
  );
}

export default App;